module.exports = __webpack_public_path__ + "static/8 - Raptor 5-1530516501da2ee847b9b6ae4b89ab21.jpg";